import registry from './registry'

const documentData = {
  COF: {
    name: 'Copia',
    value: 6500,
    detail:
      'Es una copia simple de una inscripción. Habitualmente se requiere para obtener una copia de un título anterior.',
    img: '/images/documentTypes/copyCertificate.png',
    names: {
      COMERCIO: 'Copia de Modificación de una Sociedad (sin vigencia)',
    },
    details: {
      COMERCIO:
        'Es una copia autorizada de cualquier inscripción del Registro de Comercio.',
      HIPOTECA:
        'Es la copia simple de una inscripción del registro respectivo. Habitualmente se requiere para complementar el estudio de título.',
      PROHIBICION:
        'Es la copia simple de una inscripción del registro respectivo. Habitualmente se requiere para complementar el estudio de título.',
    },
    validRegistry: [
      registry.PROPIEDAD,
      registry.COMERCIO,
      registry.AGUAS,
      registry.MINAS_PROPIEDADES,
      registry.MINAS_DESCUBRIMIENTO,
      registry.HIPOTECA,
      registry.PROHIBICION,
      registry.PRENDA_AGRARIA,
      registry.PRENDA_INDUSTRIAL,
    ],
  },
  CVF: {
    value: 12250,
    name: 'Copia con Vigencia o Copia con certificación de Vigencia',
    detail:
      'Es una copia autorizada de una inscripción, que indica quién es el actual dueño de una propiedad. Habitualmente este documento es solicitado por bancos o compradores, para realizar el estudio de títulos de una propiedad que será vendida.',
    img: '/images/documentTypes/validCertificate.png',
    names: {
      COMERCIO:
        'Copia de inscripción de la Constitución de una sociedad con anotaciones marginales (con vigencia)',
    },
    details: {
      COMERCIO:
        'Es una copia autorizada de la primera inscripción realizada en este Registro de Comercio respecto de una sociedad, la cual indica que no hay nota o subinscripción de que se le haya dado término.',
    },
    validRegistry: [
      registry.PROPIEDAD,
      registry.COMERCIO,
      registry.AGUAS,
      registry.MINAS_PROPIEDADES,
      registry.MINAS_DESCUBRIMIENTO,
    ],
  },
  GPLF: {
    value: 20800,
    name: 'Certificado de hipoteca y gravamenes',
    detail:
      'Es un certificado que incluye los gravámenes que afectan a un bien raíz como hipotecas, servidumbres, usufructos, etc. y prohibiciones como embargos, impedimentos bancarios o del Serviu para vender, entre otros. Este certificado es solicitado generalmente por los bancos o compradores, para realizar el estudio de títulos de una propiedad que será vendida. Este documento por defecto viene CON Litigio.',
    img: '/images/documentTypes/mortageLiensCertificate.png',
    names: {},
    details: {},
    validRegistry: [
      registry.PROPIEDAD,
      registry.AGUAS,
      registry.MINAS_PROPIEDADES,
      registry.MINAS_DESCUBRIMIENTO,
    ],
  },
  VSF: {
    name: 'Vigencia de sociedad',
    value: 11500,
    detail:
      'Certificado que indica que la sociedad está vigente. Generalmente se usa para trámites bancarios, licitaciones, contratos, etc...',
    img: '/images/documentTypes/validSociety.png',
    names: {},
    details: {},
    validRegistry: [registry.COMERCIO],
  },
  VSRLF: {
    name: 'Vigencia de sociedad con Representante legal',
    value: 11500,
    detail:
      'Certificado que indica que la sociedad está vigente y además menciona al representante legal que indica la inscripción. Generalmente se usa para trámites bancarios, licitaciones, contratos, etc...',
    img: '/images/documentTypes/validSociety.png',
    names: {},
    details: {},
    validRegistry: [registry.COMERCIO],
  },
  TIF: {
    name: 'Titulación',
    value: 36000,
    detail:
      'Es una carpeta que contiene copia autorizada de la inscripción de una propiedad, con constancia de su vigencia, certificado de Gravámenes y Prohibiciones, también conocido como GP, y un certificado donde se hace mención a los títulos anteriores, hasta 10 años, de una propiedad (No incluye copia de inscripción de los títulos anteriores mencionados en el certificado).',
    img: '/images/documentTypes/titulationCertificate.png',
    names: {},
    details: {},
    validRegistry: [registry.PROPIEDAD],
  },
  CDF: {
    name: 'Certificado de deslindes',
    value: 10000,
    detail:
      'Documento que detalla los deslindes de un predio, según los planos archivados en el Conservador, aprobados por las Direcciones de Obras Municipales o el Servicio Agrícola Ganadero. Se genera cuando no hay constancia de los deslindes en la inscripción.',
    img: '/images/documentTypes/boundariesCert.png',
    names: {},
    details: {},
    validRegistry: [registry.PROPIEDAD],
  },
  CCERF: {
    name: 'Certificado capital',
    value: 6000,
    detail:
      'Documento que indica el capital actual de la sociedad que esté inscrita en el Conservador de Bienes Raíces de Puerto Varas.',
    img: '/images/documentTypes/capitalCert.png',
    names: {},
    details: {},
    validRegistry: [registry.COMERCIO],
  },
  CP: {
    name: 'Copia de Plano',
    value: 6500,
    detail:
      'Es una copia certificada de un plano archivado en el Conservador de Bienes Raíces de Puerto Varas.',
    img: '/images/documentTypes/blueprintsCopy.png',
    names: {},
    details: {},
    optionImg: '/images/options/blueprintsCopy.png',
    validRegistry: [
      registry.PL_PROPIEDAD,
      registry.PL_HIPOTECA,
      registry.PL_PROHIBICION,
      registry.PL_COPROPIEDAD,
      registry.PL_COMERCIO,
      registry.DOC_PRIMERA_NOTARIA,
      registry.DOC_SEGUNDA_NOTARIA,
      registry.DOC_TERCERA_NOTARIA,
    ],
  },
  CDOF: {
    name: 'Copia de Documento',
    value: 6500,
    detail:
      'Es una copia certificada de un documento anexo archivado en el Conservador de Bienes Raíces de Puerto Varas.',
    img: '/images/documentTypes/documentCopy.png',
    names: {},
    details: {},
    optionImg: '/images/options/documentCopy.png',
    validRegistry: [
      registry.DOC_PROPIEDAD,
      registry.DOC_HIPOTECA,
      registry.DOC_PROHIBICION,
      registry.DOC_COPROPIEDAD,
      registry.DOC_COMERCIO,
    ],
  },
  PCVF: {
    name: 'Copia de escritura pública con vigencia',
    value: 12500,
    detail:
      'Es una copia autorizada de una escritura pública correspondiente a las Notarías de Puerto Varas o Llanquihue, que indica que no ha sido cancelada o revocada.',
    img: '/images/documentTypes/validProtocol.png',
    names: {},
    details: {},
    optionImg: '/images/options/validProtocol.png',
    validRegistry: [
      registry.PRIMERA_NOTARIA,
      registry.SEGUNDA_NOTARIA,
      registry.TERCERA_NOTARIA,
    ],
  },
  PSVF: {
    name: 'Copia de escritura pública sin vigencia',
    value: 6500,
    detail:
      'Es una copia simple de una escritura pública correspondiente a las Notarías de Puerto Varas o Llanquihue.',
    img: '/images/documentTypes/protocol.png',
    names: {},
    details: {},
    optionImg: '/images/options/protocol.png',
    validRegistry: [
      registry.PRIMERA_NOTARIA,
      registry.SEGUNDA_NOTARIA,
      registry.TERCERA_NOTARIA,
    ],
  },
  DE: {
    name: 'Desarchivo',
    value: 1650,
    detail: 'Es la solicitud del desarchivo de una causa que se encuentra archivada en el Archivero Judicial de Puerto Varas.',
    img: '/images/documentTypes/protocol.png',
    names: {},
    details: {},
    optionImg: '/images/options/protocol.png',
    validRegistry: [
      registry.CIVIL,
      registry.CRIMINAL,
      registry.LABORAL,
      registry.MENORES,
      registry.ALCOHOLES,
    ],
  },
}

export default documentData
